import { palette } from '@livable/saas-react-components';
const MuiRadio = {
  styleOverrides: {
    root: {
      color: palette.shades[600],
      marginRight: '0',
      padding: '8px',
      transition: "color ".concat(palette.transitions.short),
      '&.Mui-checked': {
        transition: 'none',
        color: palette.primary.main,
        '&:hover': {
          color: palette.primary.main
        }
      },
      '&:hover': {
        color: palette.shades[800]
      }
    }
  }
};
export default MuiRadio;